//#region DevExtreme Imports

import 'devextreme/ui/form'

//#endregion

//#region IMR imports

import { IMRBaseComponent } from '@imr/controls.angularjs/components/base'

//#endregion

import { CreateEditSupplierMessageController } from "./create-edit-supplier-message.controller"

//#region Asset Imports

import './create-edit-supplier-message.scss'
import { SUPPLIER_SERVICE_NAME } from '../../../../services/supplier'
import { USER_SESSION_SERVICE_NAME } from '../../../../services/user-session'

//#endregion

import * as TEMPLATE from './create-edit-supplier-message.tpl.html'
import { SYSTEM_INTERNATIONALIZATION_SERVICE_NAME } from '../../../../services/system'

export const COMPONENT_NAME: string = 'createEditSupplierMessage'

export class CreateEditSupplierMessageComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: CreateEditSupplierMessageController,
            services: [USER_SESSION_SERVICE_NAME, SUPPLIER_SERVICE_NAME, SYSTEM_INTERNATIONALIZATION_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}